import { render, staticRenderFns } from "./asset_policy.vue?vue&type=template&id=44f7965d"
import script from "./asset_policy.vue?vue&type=script&lang=js"
export * from "./asset_policy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports